module.exports = __webpack_public_path__ + "images_/biz-micro-services-ui/project/invoice/assets/img/invalidate_icon.png";


//////////////////
// WEBPACK FOOTER
// ../biz-micro-services-ui/project/invoice/assets/img/invalidate_icon.png
// module id = 1882
// module chunks = 367